var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.276 31.597c0 .223.18.403.403.403h5.745c.223 0 .403-.18.403-.403V15.874h4.165c.21 0 .384-.16.402-.37l.4-4.736a.403.403 0 0 0-.401-.437h-4.566V6.97c0-.788.638-1.427 1.426-1.427h3.21c.223 0 .403-.18.403-.403V.403A.403.403 0 0 0 23.463 0H18.04a5.763 5.763 0 0 0-5.763 5.763v4.568H9.403a.403.403 0 0 0-.403.402v4.738c0 .223.18.403.403.403h2.873v15.723z",
    fill: "#512211"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d43f9b017696a648e38d358f8228e90b.svg";
export { ForwardRef as ReactComponent };